
class ProductSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        new Swiper(this.querySelector('.swiper-container'), {
            spaceBetween: parseInt(this.dataset.mobileSpaceBetween),
            slidesPerView: 2.1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                1023: {
                    slidesPerView: 4,
                    spaceBetween: parseInt(this.dataset.spaceBetween)
                },

            }
        });
    }
}

customElements.define('product-slider', ProductSlider);

class SwipeSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
            new Swiper(this.querySelector('.swiper-container'), {
                slidesPerView: 2.2,
                spaceBetween: parseInt(this.dataset.spaceBetween),
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 21,
                    },
                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 21,
                    },
                    640: {
                        slidesPerView: 1.5,
                        spaceBetween: 21,
                    }
                }
            });
    }
}

customElements.define('swipe-slider', SwipeSlider);
class SwipeNavigation extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
            new Swiper(this.querySelector('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: parseInt(this.dataset.spaceBetween),
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 185,
                    },
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 21,
                    },
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 21,
                    }
                }
            });
    }
}

customElements.define('swipe-navigation', SwipeNavigation);



class PillsSlider extends  HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        new Swiper(this.querySelector('.swiper-container'), {
            slidesPerView: 'auto',
            spaceBetween: parseInt(this.dataset.spaceBetween)
        });
    }
}

customElements.define('pills-slider', PillsSlider);
